export default __webpack_public_path__ + "static/media/Contact.b4435692.PNG";